module.exports = __webpack_public_path__ + "images/emoji/clock730.e040dba28372e4e52b7f.png";